module.exports = __webpack_public_path__ + "assets/images/no-image/product@2x.681783b00fbdcf0799b1cf32cb9150c3.webp";